import type { User } from '@/types/user'

export const DEMO_COMPANY_NAME = 'Florăria Trandafirul'

/** Any password is accepted in mock mode — these emails are just shown as suggestions on the login screen. */
export const usersFixture: User[] = [
  {
    id: 'usr_0001',
    firstName: 'Andreea',
    lastName: 'Popescu',
    email: 'andreea@florariatrandafirul.ro',
    role: 'owner',
    avatarColor: '#2F4CDD',
    companyName: DEMO_COMPANY_NAME,
    onboardingCompleted: true,
  },
  {
    id: 'usr_0002',
    firstName: 'Mihai',
    lastName: 'Ionescu',
    email: 'mihai@florariatrandafirul.ro',
    role: 'operator',
    avatarColor: '#16A34A',
    companyName: DEMO_COMPANY_NAME,
    onboardingCompleted: true,
  },
  {
    id: 'usr_0003',
    firstName: 'Ioana',
    lastName: 'Constantinescu',
    email: 'ioana@florariatrandafirul.ro',
    role: 'marketing',
    avatarColor: '#D97706',
    companyName: DEMO_COMPANY_NAME,
    onboardingCompleted: true,
  },
  {
    id: 'usr_0004',
    firstName: 'Bogdan',
    lastName: 'Neagu',
    email: 'bogdan@florariatrandafirul.ro',
    role: 'admin',
    avatarColor: '#8B5CF6',
    companyName: DEMO_COMPANY_NAME,
    onboardingCompleted: true,
  },
  {
    id: 'usr_0005',
    firstName: 'Raluca',
    lastName: 'Toma',
    email: 'raluca@florariatrandafirul.ro',
    role: 'viewer',
    avatarColor: '#DC2626',
    companyName: DEMO_COMPANY_NAME,
    onboardingCompleted: true,
  },
]
